import Vue from 'vue'

import { formatDate } from './date'

Vue.filter('formatDate', formatDate)
